import { render, staticRenderFns } from "./PendingOrdersButton.vue?vue&type=template&id=e173a0ea&"
import script from "./PendingOrdersButton.vue?vue&type=script&lang=js&"
export * from "./PendingOrdersButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports